import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FaCircle, FaRegUserCircle } from 'react-icons/fa';
import { RiTaskFill } from 'react-icons/ri';
import { SiTask } from 'react-icons/si';
const TaskCard = ({ issue, columnId }) => {
  const {
    fields: { summary, issuetype, parent },
    key,
  } = issue;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: issue.id,
    data: {
      type: 'task',
      issue: { ...issue, columnId },
    },
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  if (isDragging) {
    return (
      <div className="h-[120px] w-[380px] rounded-lg bg-[#25252a] p-4 opacity-30"></div>
    );
  }
  return (
    <div
      className="rounded-lg bg-zinc-900  p-4 text-gray-400"
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <div className="inline-flex items-center gap-2">
            <RiTaskFill className="text-green-500" size={12} />
            <span className="text-sm">{key}</span>
          </div>
          <span>
            <FaRegUserCircle className="text-white" size={18} />
          </span>
        </div>
        <div className="flex gap-3">
          <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-blue-600">
            <SiTask size={12} className="text-white" />
          </span>
          <h3 className="text-base font-semibold">{summary}</h3>
        </div>
        <div className="mt-2 flex items-center justify-between gap-2">
          <div className="inline-flex items-center gap-1 rounded-2xl border px-1.5 py-0.5">
            <span>
              <FaCircle
                className={`${
                  issuetype.name === 'Story'
                    ? 'text-green-500'
                    : 'text-orange-500'
                }`}
                size={12}
              />
            </span>
            <span className="text-sm font-semibold">{issuetype.name}</span>
          </div>
          {issuetype.name === 'Story' && parent?.fields?.summary && (
            <span className="inline-block max-w-[200px] truncate rounded-xl border bg-black px-1.5 py-0.5 text-base font-semibold">
              {parent?.fields?.summary}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskCard;
